// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.value_your_trade_card[data-v-5e1bb30a] {
  border: 1px solid #eee;
  border-radius: 15px;
  padding: 5px;
}
.custom_legend[data-v-5e1bb30a] {
  position: absolute;
  display: inline-block;
  background: #fff;
  z-index: 9;
  font-size: 12px;
  top: -12px;
  left: 30px;
  padding: 0 6px;
  color: #000;
  opacity: 0.8;
}
.card_font_sizes h5[data-v-5e1bb30a] {
  font-size: 12px;
  font-weight: 600;
  color: #000;
  white-space: initial;
  margin: 0;
}
.card_font_sizes p[data-v-5e1bb30a] {
  margin-bottom: 3px;
  font-size: 11px;
  white-space: initial;
}
.min-120[data-v-5e1bb30a] {
  min-height: 100px;
}
.min_100[data-v-5e1bb30a] {
  display: inline-block;
  min-width: 150px;
  font-size: 13px;
}
.tvm_payment_progress[data-v-5e1bb30a] {
  border: 1px solid #eee;
  border-radius: 15px;
  padding: 5px;
}
.tvm_payment_progress span[data-v-5e1bb30a] {
  font-size: 13px;
}
.tvm_payment_progress .progress_bar[data-v-5e1bb30a] {
  height: 45px;
  object-fit: contain;
}
.tvm_payment_progress .left_value[data-v-5e1bb30a] {
  left: -7px;
  top: 35px;
}
.tvm_payment_progress .middle_value[data-v-5e1bb30a] {
  right: 80px;
  top: 42px;
}
.tvm_payment_progress .right_value[data-v-5e1bb30a] {
  right: -7px;
  top: 35px;
}
@media screen and (min-width: 1900px) {
.tvm_payment_progress .middle_value[data-v-5e1bb30a] {
    right: 100px;
    top: 46px;
}
}
.animate_bottom[data-v-5e1bb30a] {
  animation: animateBottom-5e1bb30a 2s;
  transition: 0.5s;
}
@keyframes animateBottom-5e1bb30a {
0% {
    transform: translateY(50px);
}
100% {
    transform: translateY(0);
}
}
@media (min-width: 1900px) {
.custom_legend[data-v-5e1bb30a] {
    font-size: 13px;
}
}
`, "",{"version":3,"sources":["webpack://./src/Components/ChatWidget/SlideOutPanel/TvmSlideOutBbTradeValue/TvmSlideOutBbTradeValue.vue","webpack://./TvmSlideOutBbTradeValue.vue"],"names":[],"mappings":"AAEA;EACE,sBAAA;EACA,mBAAA;EACA,YAAA;ACDF;ADIA;EACE,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,UAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;ACFF;ADKA;EAEI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;EACA,SAAA;ACJJ;ADFA;EASI,kBAAA;EACA,eAAA;EACA,oBAAA;ACJJ;ADOA;EACE,iBAAA;ACLF;ADOA;EACE,qBAAA;EACA,gBAAA;EACA,eAAA;ACLF;ADSA;EA1CE,sBAAA;EACA,mBAAA;EACA,YAAA;ACoCF;ADIA;EAGI,eAAA;ACJJ;ADCA;EAOI,YAAA;EACA,mBAAA;ACLJ;ADHA;EAYI,UAAA;EACA,SAAA;ACNJ;ADPA;EAiBI,WAAA;EACA,SAAA;ACPJ;ADXA;EAsBI,WAAA;EACA,SAAA;ACRJ;ADWE;AAAA;IAEI,YAAA;IACA,SAAA;ACTJ;AACF;ADaA;EACE,oCAAA;EACA,gBAAA;ACXF;ADcA;AACE;IACE,2BAAA;ACZF;ADeA;IACE,wBAAA;ACbF;AACF;ADeA;AACE;IACE,eAAA;ACbF;AACF","sourcesContent":["\n// reuseable css\n.value_your_trade_card {\n  border: 1px solid #eee;\n  border-radius: 15px;\n  padding: 5px;\n}\n\n.custom_legend {\n  position: absolute;\n  display: inline-block;\n  background: #fff;\n  z-index: 9;\n  font-size: 12px;\n  top: -12px;\n  left: 30px;\n  padding: 0 6px;\n  color: #000;\n  opacity: 0.8;\n}\n\n.card_font_sizes {\n  h5 {\n    font-size: 12px;\n    font-weight: 600;\n    color: #000;\n    white-space: initial;\n    margin: 0;\n  }\n  p {\n    margin-bottom: 3px;\n    font-size: 11px;\n    white-space: initial;\n  }\n}\n.min-120 {\n  min-height: 100px;\n}\n.min_100 {\n  display: inline-block;\n  min-width: 150px;\n  font-size: 13px;\n}\n\n// end reuseable css\n.tvm_payment_progress {\n  .value_your_trade_card();\n  span {\n    font-size: 13px;\n  }\n\n  .progress_bar {\n    height: 45px;\n    object-fit: contain;\n  }\n\n  .left_value {\n    left: -7px;\n    top: 35px;\n  }\n\n  .middle_value {\n    right: 80px;\n    top: 42px;\n  }\n\n  .right_value {\n    right: -7px;\n    top: 35px;\n  }\n\n  @media screen and (min-width: 1900px) {\n    .middle_value {\n      right: 100px;\n      top: 46px;\n    }\n  }\n}\n\n.animate_bottom {\n  animation: animateBottom 2s;\n  transition: 0.5s;\n}\n\n@keyframes animateBottom {\n  0% {\n    transform: translateY(50px);\n  }\n\n  100% {\n    transform: translateY(0);\n  }\n}\n@media (min-width: 1900px) {\n  .custom_legend {\n    font-size: 13px;\n  }\n}\n",".value_your_trade_card {\n  border: 1px solid #eee;\n  border-radius: 15px;\n  padding: 5px;\n}\n.custom_legend {\n  position: absolute;\n  display: inline-block;\n  background: #fff;\n  z-index: 9;\n  font-size: 12px;\n  top: -12px;\n  left: 30px;\n  padding: 0 6px;\n  color: #000;\n  opacity: 0.8;\n}\n.card_font_sizes h5 {\n  font-size: 12px;\n  font-weight: 600;\n  color: #000;\n  white-space: initial;\n  margin: 0;\n}\n.card_font_sizes p {\n  margin-bottom: 3px;\n  font-size: 11px;\n  white-space: initial;\n}\n.min-120 {\n  min-height: 100px;\n}\n.min_100 {\n  display: inline-block;\n  min-width: 150px;\n  font-size: 13px;\n}\n.tvm_payment_progress {\n  border: 1px solid #eee;\n  border-radius: 15px;\n  padding: 5px;\n}\n.tvm_payment_progress span {\n  font-size: 13px;\n}\n.tvm_payment_progress .progress_bar {\n  height: 45px;\n  object-fit: contain;\n}\n.tvm_payment_progress .left_value {\n  left: -7px;\n  top: 35px;\n}\n.tvm_payment_progress .middle_value {\n  right: 80px;\n  top: 42px;\n}\n.tvm_payment_progress .right_value {\n  right: -7px;\n  top: 35px;\n}\n@media screen and (min-width: 1900px) {\n  .tvm_payment_progress .middle_value {\n    right: 100px;\n    top: 46px;\n  }\n}\n.animate_bottom {\n  animation: animateBottom 2s;\n  transition: 0.5s;\n}\n@keyframes animateBottom {\n  0% {\n    transform: translateY(50px);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n@media (min-width: 1900px) {\n  .custom_legend {\n    font-size: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
